import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/Home'
import News from  '../view/News'
import NewsDetail from "../view/NewsDetail";
import Honor from "../view/honor";
import Download from "../view/download";
import VacuumValve1 from "../view/VacuumValve-1";
import VacuumValve2 from "../view/VacuumValve-2";
import VacuumValve3 from "../view/VacuumValve-3";
import VacuumValve4 from "../view/VacuumValve-4";
import VacuumValve5 from "../view/VacuumValve-5";
import VacuumValve6 from "../view/VacuumValve-6";
import VacuumValve7 from "../view/VacuumValve-7";
import VacuumValve8 from "../view/VacuumValve-8";
import VacuumValveMain from "../view/VacuumValveMain";
import presys from "../view/presys";
import PresysBriefIntroduction from "../view/PresysBriefIntroduction";
import PresysProcess from "../view/presysProcess";
import presysDetail from "../view/presysDetail";
import ValveRepairDndMaintenance from "../view/valveRepairDndMaintenance";
import UpgradeDndTransformation from "../view/upgradeDndTransformation";
import ServiceCenter from "../view/serviceCenter";
import throttleValve from "../view/throttleValve";
import throttleValveController from "../view/throttleValveController";
import dualThrottleValve from "../view/dualThrottleValve";
import multiPositionController from "../view/multiPositionController";
import mne from "../view/mne";
import unisemChiller from "../view/unisemChiller";
import about from "../view/about";
import CompanyProfile from "../view/CompanyProfile";
import developmentPath from "../view/developmentPath";
import CareerOpportunities from "../view/CareerOpportunities";
import recruitment from "../view/recruitment";
import contactUs from "../view/contactUs";
import login from "../view/login";
import register from "../view/register";
import retrievePassword from "../view/retrievePassword";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      redirect: '/home',
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/News",
      name: "News",
      component: News,
    },
    {
      path: "/NewsDetail",
      name: "NewsDetail",
      component: NewsDetail,
    },
    {
      path: "/honor",
      name: "Honor",
      component: Honor,
    },
    {
      path: "/download",
      name: "Download",
      component: Download,
    },
    {
      path: "/VacuumValve1",
      name: "VacuumValve1",
      component: VacuumValve1,
    },
    {
      path: "/VacuumValve2",
      name: "VacuumValve2",
      component: VacuumValve2,
    },
    {
      path: "/VacuumValve3",
      name: "VacuumValve3",
      component: VacuumValve3,
    },
    {
      path: "/VacuumValve4",
      name: "VacuumValve4",
      component: VacuumValve4,
    },
    {
      path: "/VacuumValve5",
      name: "VacuumValve5",
      component: VacuumValve5,
    },
    {
      path: "/VacuumValve6",
      name: "VacuumValve6",
      component: VacuumValve6,
    },
    {
      path: "/VacuumValve7",
      name: "VacuumValve7",
      component: VacuumValve7,
    },
    {
      path: "/VacuumValve8",
      name: "VacuumValve8",
      component: VacuumValve8,
    },
    {
      path: "/VacuumValveMain",
      name: "VacuumValveMain",
      component: VacuumValveMain,
    },
    {
      path: '/Presys',
      name: 'Presys',
      component: presys
    },
    {
      path: '/PresysBriefIntroduction',
      name: 'PresysBriefIntroduction',
      component: PresysBriefIntroduction
    },
    {
      path: '/PresysProcess',
      name: 'PresysProcess',
      component: PresysProcess
    },
    {
      path: '/presysDetail',
      name: 'presysDetail',
      component: presysDetail
    },
    {
      path: '/ValveRepairDndMaintenance',
      name: 'ValveRepairDndMaintenance',
      component: ValveRepairDndMaintenance
    },
    {
      path: '/UpgradeDndTransformation',
      name: 'UpgradeDndTransformation',
      component: UpgradeDndTransformation
    },
    {
      path: '/ServiceCenter',
      name: 'ServiceCenter',
      component: ServiceCenter
    },
    {
      path: '/throttleValve',
      name: 'throttleValve',
      component: throttleValve
    },
    {
      path: '/throttleValveController',
      name: 'throttleValveController',
      component: throttleValveController
    },
    {
      path: '/dualThrottleValve',
      name: 'dualThrottleValve',
      component: dualThrottleValve
    },
    {
      path: '/multiPositionController',
      name: 'multiPositionController',
      component: multiPositionController
    },
    {
      path: '/mne',
      name: 'mne',
      component: mne
    },
    {
      path: '/unisemChiller',
      name: 'unisemChiller',
      component: unisemChiller
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/CompanyProfile',
      name: 'CompanyProfile',
      component: CompanyProfile
    },
    {
      path: '/developmentPath',
      name: 'developmentPath',
      component: developmentPath
    },
    {
      path: '/CareerOpportunities',
      name: 'CareerOpportunities',
      component: CareerOpportunities
    },
    {
      path: '/recruitment',
      name: 'recruitment',
      component: recruitment
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/retrievePassword',
      name: 'retrievePassword',
      component: retrievePassword
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js